// @generated by protoc-gen-connect-es v1.7.0 with parameter "target=ts"
// @generated from file tracker/v1/tag_manager.proto (package tracker.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { CreateSnippetRequest, CreateSnippetResponse, DebugFireRequest, DebugFireResponse, DeleteSnippetRequest, DeleteSnippetResponse, GetSnippetRequest, GetSnippetResponse, ListSnippetsRequest, ListSnippetsResponse, ListVersionsRequest, ListVersionsResponse, PublishSnippetRequest, PublishSnippetResponse, RollbackSnippetRequest, RollbackSnippetResponse, TestFireDestinationRequest, TestFireDestinationResponse, UpdateSnippetRequest, UpdateSnippetResponse } from "./tag_manager_pb.js";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * @generated from service tracker.v1.TagManagerService
 */
export const TagManagerService = {
  typeName: "tracker.v1.TagManagerService",
  methods: {
    /**
     * @generated from rpc tracker.v1.TagManagerService.ListSnippets
     */
    listSnippets: {
      name: "ListSnippets",
      I: ListSnippetsRequest,
      O: ListSnippetsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc tracker.v1.TagManagerService.GetSnippet
     */
    getSnippet: {
      name: "GetSnippet",
      I: GetSnippetRequest,
      O: GetSnippetResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc tracker.v1.TagManagerService.CreateSnippet
     */
    createSnippet: {
      name: "CreateSnippet",
      I: CreateSnippetRequest,
      O: CreateSnippetResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc tracker.v1.TagManagerService.UpdateSnippet
     */
    updateSnippet: {
      name: "UpdateSnippet",
      I: UpdateSnippetRequest,
      O: UpdateSnippetResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc tracker.v1.TagManagerService.DeleteSnippet
     */
    deleteSnippet: {
      name: "DeleteSnippet",
      I: DeleteSnippetRequest,
      O: DeleteSnippetResponse,
      kind: MethodKind.Unary,
    },
    /**
     * M3
     *
     * @generated from rpc tracker.v1.TagManagerService.PublishSnippet
     */
    publishSnippet: {
      name: "PublishSnippet",
      I: PublishSnippetRequest,
      O: PublishSnippetResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc tracker.v1.TagManagerService.ListVersions
     */
    listVersions: {
      name: "ListVersions",
      I: ListVersionsRequest,
      O: ListVersionsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc tracker.v1.TagManagerService.RollbackSnippet
     */
    rollbackSnippet: {
      name: "RollbackSnippet",
      I: RollbackSnippetRequest,
      O: RollbackSnippetResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc tracker.v1.TagManagerService.DebugFire
     */
    debugFire: {
      name: "DebugFire",
      I: DebugFireRequest,
      O: DebugFireResponse,
      kind: MethodKind.Unary,
    },
    /**
     * M4
     *
     * @generated from rpc tracker.v1.TagManagerService.TestFireDestination
     */
    testFireDestination: {
      name: "TestFireDestination",
      I: TestFireDestinationRequest,
      O: TestFireDestinationResponse,
      kind: MethodKind.Unary,
    },
  }
} as const;

